export const ORDERS_LOAD_REQUEST = 'ORDERS_LOAD_REQUEST';
export const ORDERS_LOAD_SUCCESS = 'ORDERS_LOAD_SUCCESS';
export const ORDERS_LOAD_FAILURE = 'ORDERS_LOAD_FAILURE';
